<template>
    <div v-if="checkBindings" class="line-register-btn">

        <b-button variant="success" class="btn-app"
                  v-if="editable"
                  @click="get_ClientID" :disabled="loading">
            <i class="fa fa-commenting"></i>{{ $t('menu.register_app_line') }}
        </b-button>

        <div v-if="registed_info != undefined" class="registed-info-block">
            {{ $t('menu.linked') }} Line:
            <div class="registed-name">{{ registed_info.name }}</div>
            <div v-if="registed_info.type == 'group' || 'GROUP'" class="registed-type">
                {{ $t('menu.group') }}
            </div>
            <div v-else class="registed-type"> <!-- registed_info.type == 'user' || 'User' -->
                {{ $t('menu.user') }}
            </div>

            <div v-if="registed_info.updated_at">
                {{ $t('menu.updated') }}: {{ registed_info.updated_at }}
            </div>

            <div v-if="editable">
                <div class="registed-qa" @click="show_modal_QA = !show_modal_QA">
                    <!-- <i class="fa fa-mortar-board"></i> -->
                    Line {{ $t('menu.setting_info') }}
                    <i class="fa fa-question-circle"></i>
                </div>
            </div>

        </div>

        <!-- Modal 內容 -->
        <b-modal hide-header-close ok-only size="lg" ref="modal"
                v-model="show_modal_QA"
                v-if="editable"
                header-text-variant="light"
                header-bg-variant="teal" >
            <!-- header -->
            <div slot="modal-header" v-html="'Line ' + $t('menu.setting_info')"></div>

            <!-- body -->
            <div>

                <h4>
                    <div class="Question">Q 1.</div>{{ $t('other.line_notify_not_showing') }}
                </h4>
                <div>
                    <div class="Answer">Answer 1.1.</div>{{ $t('other.plz_check_add_line_friend') }}
                    <div class="help-link">
                        <a :href="'https://help2.line.me/line_notify/web/pc?lang=' + helpLanguage + '&contentId=20003054'" target="blank">
                            {{ $t('other.line_help') }} <i class="fa fa-external-link-square"></i>
                        </a>
                    </div>
                </div>
                <div>
                    <div class="Answer">Answer 1.2.</div>{{ $t('other.plz_check_add_line_to_group') }}
                    <div class="help-link">
                        <a :href="'https://help2.line.me/line_notify/web/pc?lang=' + helpLanguage + '&contentId=20003055'" target="blank">
                            {{ $t('other.line_help') }} <i class="fa fa-external-link-square"></i>
                        </a>
                    </div>
                </div>

                <br>

                <h4>
                    <div class="Question">Q 2.</div>{{ $t('other.project_line_binded_count') }}
                </h4>
                <div>
                    <div class="Answer">Answer.</div>{{ $t('other.a_project_a_line_group') }}
                </div>

                <br>

                <h4>
                    <div class="Question">Q 3.</div>{{ $t('other.line_contact') }}
                </h4>
                <div>
                    <div class="Answer">Answer.</div>
                    <ul>
                        <li>{{ $t('other.detected_stress_alerts') }}</li>
                        <li>{{ $t('other.detected_device_alerts') }}</li>
                        <li>{{ $t('other.public_warning') }}</li>
                        <li>{{ $t('other.service_binding_info') }}</li>
                    </ul>
                </div>

                <br>

                <div v-if="registed_info != undefined">

                    <h4>
                        <div class="Question">Q 4.</div>{{ $t('other.how_to_unlink_this_service') }}
                    </h4>
                    <div>
                        <div class="Answer">Answer.</div>
                        <b-button variant="danger" class="btn btn-red" @click="unlink_Service">
                            <i class="fa fa-ban"></i>
                            {{ $t('other.plz_press_the_button_to_unlink') }}
                        </b-button>
                    </div>

                    <br><br>

                    <b-alert variant="danger" show v-if="user_admin">
                        <h3>Admin Eyes</h3>
                        <ul>
                            <li>Code：{{ registed_info.code }}</li>
                            <li>Token：{{ registed_info.token }}</li>
                            <li>Token ID：{{ registed_info.id }}</li>
                            <li>Token Name：{{ registed_info.name }}</li>
                            <li>Token Type：{{ registed_info.type }}</li>
                            <li>Token Updated：{{ registed_info.updated_at }}</li>
                            <li>Token Created：{{ registed_info.created_at }}</li>
                            <li>Token Note：{{ registed_info.note }}</li>
                        </ul>
                    </b-alert>

                </div>

            </div>

            <!-- footer -->
            <div slot="modal-footer" class="w-100">
                <div class="float-left">
                    <!-- HashTag -->
                    <!-- <i class="fa fa-hashtag"></i>Line {{ $t('menu.setting_info') }} -->

                </div>

                <!-- <b-btn class="btn-agri float-right" variant="success" @click="uploadNote()" :disabled="checkDisabled">{{ $t('menu.upload') }}</b-btn> -->
                <b-btn class="float-right" variant="warning" @click="show_modal_QA = false">{{ $t('menu.close') }}</b-btn>
            </div>
        </b-modal>

    </div>
</template>

<script>
    import { mapState } from 'vuex'

    export default {
        props: {
            projectID: {
                type: Number,
                required: true,
            },
            timezone: {
                type: String,
                default: 'Asia/Taipei',
            },
            editable: {
                type: Boolean,
                default: false,
            },
        },
        data () {
            return {
                loading: false,
                registed_info: undefined,
                show_modal_QA: false,
            }
        },
        mounted ()
        {
            this.get_LineNotifyToken()
        },
        computed: {
            ...mapState({
                'language': state => state.user.language,
                'user_admin': state => state.user.is_admin,
            }),

            checkBindings ()
            {
                if ( this.projectID != undefined ) return true

                return false
            },

            getSettingPageURL ()
            {
                if ( this.projectID != undefined )
                {
                    let _host = location.origin
                    // let _host = ( location.host == 'localhost:8080' ? 'http://' : 'https://' ) + location.host

                    let routeData = this.$router.resolve( { name: 'Line Notify' } );

                    return _host + routeData.href
                }
            },

            helpLanguage ()
            {
                switch ( this.language )
                {
                    case 'zh-Hant-TW': return 'zh-Hant';
                    default: return 'en';
                }
            },

        },
        methods: {

            unlink_Service ()
            {
                if ( confirm( this.$t('other.confirm_delete') ) == true )
                {
                    this.show_modal_QA = false;
                    this.loading = true;

                    const options = {
                        method: 'DELETE',
                        url: this.$config.getAPI_URL('API') + 'projects/' + this.projectID + '/linenotify',
                    }
                    this.$http(options)
                        .then(res => {
                            this.loading = false;
                            this.get_LineNotifyToken()

                            this.$toastr.s(this.$t('other.update_succeeded'),
                                       '已移除 Line 通知服務');
                        })
                        .catch(err => {
                            this.loading = false;

                            this.$toastr.e(this.$t('other.update_failed') + '<br>' + err.data.status + '<br>' + err.data.message,
                                        '無法移除 Line 通知服務，請重整頁面後再試或連繫客服人員');
                        })

                    // 送出使用者操作紀錄 --------------------
                    let _OPLog = {
                        user_id: this.$store.state.user.id,
                        type: 'delete',
                        detail: {
                            page: 'project - line',
                            action: 'unlink line notify',
                            querySettings: {
                                'project ID':   this.projectID,
                                'line id':      this.registed_info.id,
                                'line name':    this.registed_info.name,
                                'line type':    this.registed_info.type,
                                // 'line code':    this.registed_info.code,
                                // 'line token':   this.registed_info.token,
                            },
                        },
                    }
                    this.$store.dispatch('user/createLog', _OPLog).then( res => {}).catch( err => {})
                    // 送出使用者操作紀錄 --------------------
                }
            },

            get_LineNotifyToken ()
            {
                this.loading = true;
                this.registed_info = undefined;

                const options = {
                    method: 'GET',
                    url: this.$config.getAPI_URL('API') + 'projects/' + this.projectID + '/linenotify',
                }
                this.$http(options)
                    .then(res => {
                        this.loading = false;
                        // console.log( res.data.token_info )

                        this.registed_info = res.data.token_info;
                        if ( this.registed_info != undefined )
                        {
                            if ( this.registed_info.type != undefined )         this.registed_info.type = this.registed_info.type.toLowerCase()
                            if ( this.registed_info.created_at != undefined )   this.registed_info.created_at = this.$tools.date.dateTimeZone( this.registed_info.created_at, this.timezone, 'YYYY-MM-DD HH:mm' )
                            if ( this.registed_info.updated_at != undefined )   this.registed_info.updated_at = this.$tools.date.dateTimeZone( this.registed_info.updated_at, this.timezone, 'YYYY-MM-DD HH:mm' )
                        }

                    })
                    .catch(err => {
                        this.loading = false;
                        this.registed_info = undefined;
                    })
            },

            /**
             * get_ClientID - 先從資料庫取得草苗龜註冊的 APP ID
             */
            get_ClientID ()
            {
                this.loading = true;
                const options = {
                    method: 'GET',
                    url: this.$config.getAPI_URL('API') + 'services/line_notify_info',
                }
                this.$http(options)
                    .then(res => {
                        this.loading = false;
                        // console.log( res.data )

                        if ( res.data && res.data.service_id != undefined )
                        {
                            this.register_LineNotify( res.data.service_id )
                            this.$toastr.s(this.$t('other.update_succeeded'),
                                       '已取得阿龜驗證，正在導向 Line 官方授權頁面，請耐心等候');
                        }
                        else
                        {
                            this.$toastr.e(this.$t('other.update_failed') + '<br>' + err.data.status + '<br>' + err.data.message,
                                        '無法取得阿龜驗證，請重整頁面後再試或連繫客服人員');
                        }

                    })
                    .catch(err => {
                        this.loading = false;
                        this.$toastr.e(this.$t('other.update_failed') + '<br>' + err.data.status + '<br>' + err.data.message,
                                        '無法取得阿龜驗證，請重整頁面後再試或連繫客服人員');
                    })

            },

            /**
             * register_LineNotify - 往外連到line官方授權頁，註冊取得使用者/群組 token
             */
            register_LineNotify (client_id)
            {
                try {
                    let _URL = 'https://notify-bot.line.me/oauth/authorize?';
                    _URL += 'response_type=code';
                    _URL += '&client_id=' + client_id;                      // cliend_id : APP 的 client_id，可以從 [GET] /api/services/line_notify_info 取得
                    _URL += '&redirect_uri=' + this.getSettingPageURL;      // redirect_uri : 取得 token 後要導向的第二個頁面設定，為 callback 的頁面
                    _URL += '&scope=notify';
                    _URL += '&state=' + this.projectID;                     // state: 可以帶 project id
                    window.location.href = _URL;

                    // 送出使用者操作紀錄 --------------------
                    let _OPLog = {
                        user_id: this.$store.state.user.id,
                        type: 'write',
                        detail: {
                            page: 'project - line',
                            action: 'link line notify',
                            querySettings: {
                                'project ID':   this.projectID,
                            },
                        },
                    }
                    this.$store.dispatch('user/createLog', _OPLog).then( res => {}).catch( err => {})
                    // 送出使用者操作紀錄 --------------------
                }
                catch (err) {
                    // console.log( err )
                    this.$toastr.e(this.$t('other.update_failed'),
                                        '申請 Line 官方授權過程中發生問題，請重整頁面後再試或連繫客服人員');
                }
            },

        },
    }
</script>

<style lang="scss" scoped>

.line-register-btn
{
    display: inline-block;
    text-align: left;
    // float: right;
    margin: 0px 5px 5px 0px;
}

.registed-info-block
{
    font-size: 1.0rem;
    margin: 5px;
}

.registed-name
{
    display: inline-block;
    color: #1da543;
    font-weight: 600;
    padding: 2px 5px;
}
.registed-type
{
    display: inline-block;
    padding: 1px 5px;
    margin: 2px 5px;
    border-radius: 10px;
    // background-color: #3f9056;
    // color: white;
    border: 1px solid #3f9056;
    color: #3f9056;
    font-size: 0.9rem;
}

$QA-color: #3d6c4b;
$QA-color-hover: #319d51;
.registed-qa
{
    cursor: pointer;
    float: right;
    // text-decoration: underline;
    color: $QA-color;
    border-bottom: 1px solid $QA-color;

    &:hover
    {
        color: $QA-color-hover;
        border-bottom: 1px solid $QA-color-hover;
    }
}

.Question
{
    display: inline-block;
    margin-right: 10px;
    font-size: 1.2rem;
    font-weight: 600;
    color: #da5e5e;
}
.Answer
{
    display: inline-block;
    margin-right: 10px;
    font-size: 1.2rem;
    font-weight: 600;
    color: #4e916e;
}

.help-link
{
    display: inline-block;
    margin: 1px 5px;
    padding: 3px 8px;
    border-radius: 5px;
    border: 1px solid #7dae54;
}

</style>
